import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import styles from './PageHeader.module.scss'

const PageHeader = ({ title, subtitle, actions, alert, children, variant = 'default', className, statusChip }) => (
  <div className={`${variant === 'card' ? styles.headerCard : styles.header}${className ? ` ${className}` : ''}`}>
    {alert && <div className={styles.alertSection}>{alert}</div>}
    <div className={styles.headerTop}>
      <div className={styles.titleSection}>
        <div className={styles.titleRow}>
          <Typography variant='h4' component='h1' className={styles.title}>
            {title}
          </Typography>
          {statusChip && <span className={styles.statusChip}>{statusChip}</span>}
        </div>
        {subtitle && (
          <Typography variant='body2' className={styles.subtitle}>
            {subtitle}
          </Typography>
        )}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
    {children}
  </div>
)

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  alert: PropTypes.node,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'card']),
  className: PropTypes.string,
  statusChip: PropTypes.node
}

export default PageHeader
